import React, { Component } from 'react'
import { IoIosArrowForward } from 'react-icons/io';
import { Link } from 'react-router-dom';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import { AiFillWarning } from "react-icons/ai";
import SelectedPlan from '../../components/SelectedPlan/SelectedPlan';
import toastr from 'toastr';
import purchasedPack from '../../actions/purchasedPack'


class Plan extends Component {
    constructor(props){
        super(props);
        this.state = {
            modal: false,
            user: true
        }

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.cancelPack = this.cancelPack.bind(this);
    }

    cancelPack(){
        

        /* API */
        this.setState({isLoading: true});
        purchasedPack.cancelPurchasedPack().then(response => {

            purchasedPack.getPurchaseHistory().then((cartResponse) => {

                window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                window.dataLayer.push({
                'event': 'refund',
                'ecommerce': {
                    'refund': {
                    'actionField': {'id':  cartResponse.data.data[0].cart_id.toUpperCase() }         // Transaction ID. Required for purchases and refunds.
                    }
                }});
    
                toastr.options = {
                    positionClass : 'toast-top-full-width',
                    hideDuration: 300,
                    timeOut: 10000
                }
                toastr.clear();
                setTimeout(() => toastr.success(`Cancelamento foi realizado com sucesso.<br />
                                                Você terá acesso até o fim do seu período de pagamento.<br />
                                                Volte quando quiser.`), 300);
    
                this.setState({isLoading: false});
                this.props.history.push('/dashboard');
            });

        }).catch(error => {


            this.setState({
                isLoading: false,
                errorMessage: error.response.data.data.message
            });

            toastr.options = {
                positionClass : 'toast-top-full-width',
                hideDuration: 300,
                timeOut: 6000
            }
            toastr.clear()
            setTimeout(() => toastr.error(`${this.state.errorMessage}`), 300);

            this.props.history.push('/dashboard');
            
        });
    }

    openModal(){
        this.setState({
            modal: true
        })
    }

    closeModal(){
        this.setState({
            modal: false
        })
    }

    render(){ 

        return(
            <div className="page-container page">
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className="modal"
                    open={this.state.modal}
                    onClose={this.closeModal}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                    timeout: 500,
                    }}
                >
                    <Fade in={this.state.modal}>
                        <div className="modalContent text-center">
                            <h2 className="modalTitle">
                                <AiFillWarning size="60px" /><br /><br />
                                ATENÇÃO</h2>
                            <div>
                                Tem certeza que deseja <strong>CANCELAR</strong> seu plano?
                            </div>
                            <a className="btn-default mt-4 mb-4" onClick={this.closeModal}>Não e fechar</a><br />
                            <a className="link-default danger" onClick={this.cancelPack}>Sim, desejo cancelar</a>
                        </div>
                    </Fade>
                </Modal>

                <div className="title">Dashboard</div>
            
                <SelectedPlan user={this.state.user} />

                <div className="position-relative">
                    <div className="p-5">

                    <div className="menu-list">
                        <Link to="/dashboard/plan/change">
                            <div className="menu-list--item">
                                <h2>Alterar plano</h2>
                                <p>Escolha outro plano para você!</p>
                                <IoIosArrowForward />
                            </div>
                        </Link>
                        <Link to="/dashboard/plan/payment-change">
                            <div className="menu-list--item">
                                <h2>Alterar forma de pagamento</h2>
                                <p>Altere o cartão cadastrado</p>
                                <IoIosArrowForward />
                            </div>
                        </Link>
                        <Link onClick={() => this.openModal()}>
                            <div className="menu-list--item">
                                <h2>Cancelar plano</h2>
                                <p>Não deseja mais o FC Saúde? Clique aqui</p>
                                <IoIosArrowForward />
                            </div>
                        </Link>
                    </div>

                    </div>
                </div>
            </div>
        )
    }
}

export default Plan;